import React from "react";
import { ECLDialogButtonBar, ECLNumber } from "../../../index";
import { translate } from "../../../../utilities/Translate";
import useSelectorId from "../../../../utilities/hooks/useSelectorId";

export default function TableNumericRangeFilter(props) {
   const instanceId = useSelectorId();

   function getValues() {
      const min = document.querySelector(
         "#table-range-filter-min" + instanceId,
      )?.value;
      const max = document.querySelector(
         "#table-range-filter-max" + instanceId,
      )?.value;
      return [min && Number(min), max && Number(max)];
   }

   function clearValues() {
      const min = document.querySelector(
         "#table-range-filter-min" + instanceId,
      );
      const max = document.querySelector(
         "#table-range-filter-max" + instanceId,
      );
      if (max) max.value = props.max;
      if (min) min.value = props.min;
   }

   return (
      <div className="table-filter-container">
         <ECLNumber
            id={"table-range-filter-min" + instanceId}
            name="Min"
            value={props.defaultValueMin}
            min={props.min}
            max={props.max}
            precision={props.precision}
            onChange={() => {
               props.setRangeFunction(getValues());
            }}
         />
         <ECLNumber
            id={"table-range-filter-max" + instanceId}
            name="Max"
            min={props.min}
            max={props.max}
            value={props.defaultValueMax}
            precision={props.precision}
            onChange={() => {
               props.setRangeFunction(getValues());
            }}
         />
         <ECLDialogButtonBar>
            <button
               onClick={(e) => {
                  e.preventDefault();
                  props.clearRangeFunction();
                  clearValues();
               }}
            >
               {translate("Reset")}
            </button>
         </ECLDialogButtonBar>
      </div>
   );
}
